import { https , httpsFile } from './http.js';

export function index () {
    return https().get('product-hierarchy');
}